// extracted by mini-css-extract-plugin
module.exports = {"footer":"_45e9800","footerNavs":"_226a0e0","footerBottom":"_be003a1","footerBottomInner":"_d731253","copyrightText":"_18686f8"};